import { render, staticRenderFns } from "./SlglrsBaseHeaderSec.vue?vue&type=template&id=44b38541&scoped=true&"
import script from "./SlglrsBaseHeaderSec.vue?vue&type=script&lang=js&"
export * from "./SlglrsBaseHeaderSec.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b38541",
  null
  
)

export default component.exports